import { jsx as _jsx } from "react/jsx-runtime";
import { Field, useFormikContext } from "formik";
import { UppercaseTextField } from "@ploy-ui/form-fields";
import { useIntl } from "react-intl";
import { messages } from "../messages";
export const RegistrationNumberField = ({ onGetContract, contractIsLoading, onResetForm }) => {
    const intl = useIntl();
    const { values, isSubmitting, setFieldValue } = useFormikContext();
    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            if (values.registrationNumber.trim()) {
                if (onResetForm) {
                    onResetForm();
                }
                setFieldValue("buyoutDate", "");
                setFieldValue("mileage", undefined);
                onGetContract(values.registrationNumber.trim());
            }
        }
    };
    return (_jsx(Field, { name: "registrationNumber", label: intl.formatMessage(messages.registrationNumber), variant: "outlined", component: UppercaseTextField, disabled: contractIsLoading || isSubmitting, fullWidth: true, InputLabelProps: { shrink: true }, autoFocus: true, onKeyDown: handleKeyDown }));
};
//# sourceMappingURL=RegistrationNumberField.js.map